import { createMultiInviteTextRows as createBulkProcessTextRows } from '@components/process-invite-guest/utils/create-multi-invite-text-rows';

import { BulkProcessRow } from './bulk-process-utils.type';

// Process bulk process text and calculate totals
export const processBulkProcessText = (bulkText: string) => {
  const rows = createBulkProcessTextRows(bulkText);
  const totalQuantity = rows.reduce((acc: number, row: BulkProcessRow) => acc + Number(row.numTickets), 0);

  return {
    rows,
    totalQuantity,
  };
};
